// extracted by mini-css-extract-plugin
export var closeButton = "_jl-2";
export var closeButtonIcon = "_jl-3";
export var lightboxContent = "_jl-1";
export var lightboxOverlay = "_jl-0";